/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeSMinusIcon16Solid = forwardRef('MediaAudioVolumeSMinusIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7.51 1.694 3.704 5H1.5A1.5 1.5 0 0 0 0 6.5v3A1.5 1.5 0 0 0 1.5 11h2.204l3.806 3.306a.9.9 0 0 0 1.49-.68V2.374a.9.9 0 0 0-1.49-.68Z" }),
        React.createElement("path", { d: "M10.7 7a.7.7 0 0 0-.7.7v.6a.7.7 0 0 0 .7.7h4.6a.7.7 0 0 0 .7-.7v-.6a.7.7 0 0 0-.7-.7h-4.6Z" })));
});
